module.exports = __webpack_public_path__ + "img/IMG_0088.303478a6.jpg";